import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib';
import { createSlice } from '@reduxjs/toolkit';

export const loggerProgrammingUiSlice = createSlice({
  name: 'logger-programming-ui',
  initialState: baseUiInitialState,
  reducers: {
    ...baseUiReducers,
  },
});
